import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import * as Chart from 'chart.js';

@Component({
  selector: '',
  template: '',
})
export class DoughnutChartHandler implements OnInit {
  @Input() doughnutChartData: any;
  @Input() doughnutChartOptions: any;
  @Input() isMultiSeries: boolean = false;
  @Input() doughnutChartTitle: string = '';
  @ViewChild('doughnutChartCanvas', { static: true }) chartCanvas!: ElementRef;

  chartInstance: any;

  constructor(public service: DashboardService) {}

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes['doughnutChartData'] && this.doughnutChartData) {
      this.renderChart();
    }
  }

  renderChart() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }

    const ctx = this.chartCanvas.nativeElement.getContext('2d');

    const doughnutLabelPlugin = {
      id: 'doughnutLabelPlugin',
      afterDraw: (chart) => {
        if (this.isMultiSeries) {
          const ctx = chart.ctx;
          chart.data.datasets.forEach((dataset, dsIndex) => {
            const meta = chart.getDatasetMeta(dsIndex);
            meta.data.forEach((arc, i) => {
              if (!arc) return;
              const value = dataset.data[i];
              if (value === 0) return;
              const label = chart.data.labels[i];

              const centerX = arc.tooltipPosition().x;
              const centerY = arc.tooltipPosition().y;

              ctx.save();
              ctx.fillStyle = '#000';
              ctx.font = 'bold 8px Arial';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              if (chart.data[i] != 0) ctx.fillText(label, centerX, centerY);
              ctx.restore();
            });
          });
        }
      },
    };

    this.chartInstance = new Chart(ctx, {
      type: 'doughnut',
      data: this.doughnutChartData,
      options: this.doughnutChartOptions,
      plugins: this.isMultiSeries ? [doughnutLabelPlugin] : [],
    });
  }

  ngOnDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
    this.service.clear();
  }
}
